const sideBarConstantsEN = {
  dashboard: 'Dashboard',
  reports: 'Reports',
  userManagement: 'User Management',
  pages: 'Pages',
  approvedDomain: 'Approved domains',
  usersApproval: 'Users Approval',
  proposalRequests: 'Proposal Requests',
  purchaseRequests: 'Purchase requests',
  reviews: 'Reviews',
  videosManagement: 'Videos management',
  logOut: 'Log Out',
  blogs: 'Blogs',
  successStories: 'Success Stories',
  news: 'News',
  messageCenter: 'Messages',
  settings: 'Settings',
  ordersManagement: 'Orders Management',
  manageProfile: 'Manage Profile',
  deletedMedia: 'Deleted Media'
};

export default sideBarConstantsEN;
